var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6201 14.9901C28.1301 14.5001 27.3401 14.5001 26.8501 14.9901L18.5401 23.3001C18.1501 23.6901 18.1501 24.3201 18.5401 24.7101L26.8501 33.0201C27.3401 33.5101 28.1301 33.5101 28.6201 33.0201C29.1101 32.5301 29.1101 31.7401 28.6201 31.2501L21.3801 24.0001L28.6301 16.7501C29.1101 16.2701 29.1101 15.4701 28.6201 14.9901Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6e8cd60c9b29143d5e809ca0a0cf0c67.svg";
export { ForwardRef as ReactComponent };